import { RequestMainService } from "../request";

export class SongService {
  static async getList(params: any = {}) {
    return RequestMainService.get(`/admin/songs`, params).then(
      ({ result }) => {
        return {
          count: result?.total,
          data: result.songs,
        };
      }
    );
  }

  static async import(params: any) {
    return RequestMainService.uploadFile(`/admin/songs/import`, params).then(
      (res) => res?.data
    );
  }

  static getFilterOptions() {
    return {
      isDuet: [
        { label: "Song ca", value: true },
        { label: "Đơn ca", value: false },
      ],
      isActive: [
        { label: "Tất cả", value: undefined },
        { label: "Kích hoạt", value: true },
        { label: "Khóa", value: false },
      ]
    }
  }

  static async delete(id: string | number) {
    return RequestMainService.delete(`/admin/songs/${id}`);
  }
}
